import { useContext } from "react";
import { RouteItemContext } from "../context.js";
/**
 * Returns the current route object.
 *
 * In most circumstances, this will be the active top-level route.
 *
 * In cases where manual rendering of routes is taking place, such as during page transitions or in some modal cases.
 *
 * @returns The current route
 */
export function useRoute() {
    return useContext(RouteItemContext);
}
/**
 * Returns the current route, if it matches the specified view, otherwise null.
 */
export function useViewRoute(view) {
    const route = useContext(RouteItemContext);
    if (route.view === view) {
        return route;
    }
    else {
        return null;
    }
}
